import React from 'react';

export function H2({content, className}) {
    return (
        <h2 className={className}>{content}</h2>
    )
}